import { Directive, HostListener, Input, OnInit } from '@angular/core';

@Directive({
  selector: '[wilsonTimerLine]',
  standalone: true,
})
export class TimerLineDirective implements OnInit {
  @Input({ required: true }) duration!: number;
  @Input({ required: true }) lineElement!: HTMLElement;

  private startTime!: number;
  private elapsedTime = 0;
  private remainingTime!: number;
  private isPaused = false;
  private animationFrameId: number | null = null;

  ngOnInit() {
    this.startTime = Date.now();
    this.remainingTime = this.duration;
    this.lineElement.style.transition = `none`;
    requestAnimationFrame(() => {
      this.updateGradient(0);
      this.startAnimation();
    });
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    if (!this.isPaused) {
      this.elapsedTime = Date.now() - this.startTime;
      this.remainingTime -= this.elapsedTime;
      this.lineElement.style.transition = 'none';
      if (this.animationFrameId) {
        cancelAnimationFrame(this.animationFrameId);
      }
      this.isPaused = true;
    }
  }

  @HostListener('mouseleave')
  onMouseLeave() {
    if (this.isPaused) {
      this.startTime = Date.now();
      this.isPaused = false;
      this.startAnimation();
    }
  }

  private updateGradient(percent: number) {
    const remainingPercent = 100 - percent;
    this.lineElement.style.background = `linear-gradient(to right, var(--primary-tint) ${remainingPercent}%, transparent ${remainingPercent}%)`;
  }

  private startAnimation() {
    const animate = () => {
      if (!this.isPaused) {
        const elapsed = Date.now() - this.startTime;
        const percent =
          ((elapsed + (this.duration - this.remainingTime)) / this.duration) *
          100;
        this.updateGradient(percent);

        if (percent < 100) {
          this.animationFrameId = requestAnimationFrame(animate);
        }
      }
    };

    this.animationFrameId = requestAnimationFrame(animate);
  }
}
